import apiClient from './api';

// Messages API wrapper
const messagesService = {
  getAll: async (params) => {
    const res = await apiClient.get('/Messages', { params });
    return res.data;
  },

  create: async (payload) => {
    const res = await apiClient.post('/Messages', payload);
    return res.data;
  },

  getById: async (id) => {
    const res = await apiClient.get(`/Messages/${id}`);
    return res.data;
  },

  update: async (id, payload) => {
    const res = await apiClient.put(`/Messages/${id}`, payload);
    return res.data;
  },

  remove: async (id) => {
    const res = await apiClient.delete(`/Messages/${id}`);
    return res.data;
  },

  getByConversation: async (conversationId, params) => {
    const res = await apiClient.get(`/Messages/conversation/${conversationId}`, { params });
    return res.data;
  },

  getLatestInConversation: async (conversationId) => {
    const res = await apiClient.get(`/Messages/conversation/${conversationId}/latest`);
    return res.data;
  },

  getUnreadCount: async (conversationId, userId) => {
    const res = await apiClient.get(`/Messages/conversation/${conversationId}/unread-count/${userId}`);
    return res.data;
  },

  getByCommunityRoom: async (communityRoomId, params) => {
    const res = await apiClient.get(`/Messages/community-room/${communityRoomId}`, { params });
    return res.data;
  },

  getBySender: async (senderId, params) => {
    const res = await apiClient.get(`/Messages/sender/${senderId}`, { params });
    return res.data;
  },

  getByType: async (messageType, params) => {
    const res = await apiClient.get(`/Messages/type/${messageType}`, { params });
    return res.data;
  },

  getUnreadForUser: async (userId, params) => {
    const res = await apiClient.get(`/Messages/unread/${userId}`, { params });
    return res.data;
  },

  search: async (queryParams) => {
    const res = await apiClient.get('/Messages/search', { params: queryParams });
    return res.data;
  },

  markRead: async (id, userId) => {
    const res = await apiClient.put(`/Messages/${id}/mark-read/${userId}`);
    return res.data;
  },

  markConversationRead: async (conversationId, userId) => {
    const res = await apiClient.put(`/Messages/conversation/${conversationId}/mark-read/${userId}`);
    return res.data;
  }
};

export { messagesService };
export default messagesService;
